// src/components/CollectionsGrid.jsx
import React from "react";
import CollectionItem from "./CollectionsItem";

function CollectionsGrid({ filter, products }) {
  // `filter` is effectively the collection handle from the URL, e.g. "all", "knickers", "underwear"
  const collectionHandle = filter || "all";

  // Map filter values to display-friendly names
  const filterTitleMap = {
    knickers: "Knicker Drawer",
    bras: "Bras",
    swim: "Swim",
    clothing: "Clothing",
    accessories: "Accessories",
    personalised: "Personalised",
    underwear: "Underwear",
    all: "All",
  };

  const displayTitle = filterTitleMap[collectionHandle] || collectionHandle;

  return (
    <div className="p-2 sm:p-8 mt-2 sm:mt-4">
      <h1 className="m-auto uppercase text-center text-sm italic mb-2">
        {displayTitle}
      </h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-6">
        {products.map((product) => (
          <CollectionItem
            key={product.id}
            product={product}
            collectionHandle={collectionHandle}
          />
        ))}
      </div>
    </div>
  );
}

export default CollectionsGrid;
